function getPostCategory(postID) {
  const wrappedPostID = postID || ''
  if (wrappedPostID.indexOf('forum') === 0) {
    // isForum
    return 'forum'
  } else if (wrappedPostID.indexOf('place') === 0) {
    // isPlace
    return 'place'
  } else {
    // isArticle
    return 'article'
  }
}

class GaEventFactory {
  static createShareEvent(via, postID) {
    const eventLabel = `${via}.${postID}`
    return {
      eventCategory: getPostCategory(postID),
      eventAction: 'share',
      eventLabel,
    }
  }

  static createSavePostEvent(postID) {
    return {
      eventCategory: getPostCategory(postID),
      eventAction: 'click.save',
      eventLabel: postID,
    }
  }

  static createUnsavePostEvent(postID) {
    return {
      eventCategory: getPostCategory(postID),
      eventAction: 'click.unsave',
      eventLabel: postID,
    }
  }
}

export default GaEventFactory
